module.exports = __webpack_public_path__ + "img/9788964373354.b8c101ee.jpg";